<template>
  <router-view />
</template>

<style>
html,
body {
  font-size: 62.5%;
}
html {
  min-height: 101vh;
  min-height: 101lvh;
}
#app {
  max-width: 840px;
  margin: auto;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #222222;
}
html,
body,
.page,
.page__content {
  overflow: visible !important;
}
.page {
  max-width: 84rem;
  margin: auto;
}
</style>
